import React, {useEffect, useState} from 'react';
import {myUserAcademy} from "@/lib/services/academyService";
import AccountSelector from "@/pages/gateway/childer/_section/AccountChildSelector";
import {useApiLoginWithChildren, useGetCurrentUser, useGetUserAcademyFamily} from "@/api/auth";
import {saveTokensChild} from "@/lib/services/tokenService";
import {URLS} from "@/lib/urls";
import {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import {useNavigate} from "react-router-dom";
import {Spin} from "antd";
import {useAuth} from "@/provider/AuthProvider";

function SelectChildren(props) {
    // const [myChildren, setMyChildren] = useState([])
    const [refetchUser, setRefetchUser] = useState(false)
    const [currentUser, setCurrentUser] = useState({})
    const {mutate: loginWithChild, isPending: isPendingLBO} = useApiLoginWithChildren()
    const {data: myChildren, isPending} = useGetUserAcademyFamily()

    const navigate = useNavigate()

    const {setUser} = useAuth()

    const {
        data: userData,
        error: userError,
        isLoading: userLoading,
        isSuccess: userSuccess,
        isError: userIsError,
    } = useGetCurrentUser({
        enabled: refetchUser,
    })

    useEffect(() => {
        if (userData?.data) {
            setUser(userData?.data);

            if (refetchUser) {
                navigate(URLS.student.dashboard, {replace: true})
            }
        }
    }, [userData, refetchUser]);

    useEffect(() => {
        setCurrentUser(myUserAcademy())

    }, [])

    if (!currentUser || !myChildren) {
        return null
    }

    if (isPending) {
        return <Spin spinning={true}/>
    }

    const handleSelectAccount = (userId, isParent) => {
        loginWithChild({
            current_user_id: currentUser.id,
            child_user_id: userId,
        }, {
            onSuccess: (r) => {
                saveTokensChild({
                    accessToken: r.data?.data?.access_token, refreshToken: r.data?.data?.refresh_token, rememberMe: true
                });

                setRefetchUser(true)


            },
            onError: (error) => {
                ApiHandleErrorMessage(error);
            }
        })

    };

    return (
        <AccountSelector
            isLoading={isPendingLBO}
            currentUser={currentUser}
            children={myChildren}
            onSelectAccount={handleSelectAccount}
        />
    );
}

export default SelectChildren;

